import { useCallback, useState } from "react";
import { useSelector } from "react-redux";
import { useParams, useSearchParams } from "react-router-dom";
import Layout from "../../../Components/Layout";
import { SocialLinkModal } from "../../../Components/EventMgt/SocialLinkModal";
import EventDetails from "../../../Components/User/Events/EventDetails";

const PublicEventDetailPage = () => {
  const { eventId } = useParams();
  const [searchParams] = useSearchParams();
  const [showShareModal, setShowShareModal] = useState(false);
  const eventData = useSelector((state) => state.event.data);
  const redirectUrl =
    searchParams.get("redirectUrl") || process.env.REACT_APP_MERCH_URL || "/";

  const shareEvent = useCallback(() => {
    setShowShareModal(true);
  }, []);

  const closeShareModal = useCallback(() => {
    setShowShareModal(false);
  }, []);

  return (
    <Layout
      Heading={
        eventData?._id === eventId ? eventData.title : "Event Details"
      }
      HeadLabel="Event Details"
      HeadChip={eventData?._id === eventId ? eventData.category : undefined}
      TitleClassName="event-details-page-title"
      HeadClassName="event-details-head"
      DetailsHead
      ExtraclassName="event-details-panel"
      SecondaryButtonHeading="Share Event"
      SecondaryButtonIcon="bi-share"
      SecondaryButtonAction={shareEvent}
      BackAction={redirectUrl}
      Sidebar={0}
    >
      <EventDetails publicAccess />
      <SocialLinkModal
        eventId={eventId}
        show={showShareModal}
        onHide={closeShareModal}
        isHideEmbeded
      />
    </Layout>
  );
};

export default PublicEventDetailPage;
